<div class="footer-background">
  <p class="footer-label">Versão {{version.name}} {{version.number}} ({{environment.name}})</p>
</div>
